import { render, staticRenderFns } from "./EmojiBtn.vue?vue&type=template&id=62b6d000&scoped=true&"
import script from "./EmojiBtn.vue?vue&type=script&lang=js&"
export * from "./EmojiBtn.vue?vue&type=script&lang=js&"
import style0 from "./EmojiBtn.vue?vue&type=style&index=0&id=62b6d000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b6d000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b6d000')) {
      api.createRecord('62b6d000', component.options)
    } else {
      api.reload('62b6d000', component.options)
    }
    module.hot.accept("./EmojiBtn.vue?vue&type=template&id=62b6d000&scoped=true&", function () {
      api.rerender('62b6d000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/a-kit/forms/EmojiBtn.vue"
export default component.exports